import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {DeliveryManStatusEnum} from 'modules/access-controls/types';
import useCitiesSelect from 'modules/cities/hooks/use-cities-select';
import useCreateDeliveryMan, {
  CreateDeliveryManProps,
  translatedCreateDeliveryManProps,
} from 'modules/delivery-men/hooks/use-create-delivery-man';
import useUsersSelect from 'modules/users/hooks/use-users-select';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateDeliveryMen: React.FC = () => {
  const {cityId} = useAccessControls();
  const {getInput, getSwitch, getSelect, getNumberInput, getAddressInput} =
    useFormInputs<CreateDeliveryManProps>();
  const {data} = useUsersSelect();
  const citiesSelect = useCitiesSelect();

  const handleSubmit = (data: CreateDeliveryManProps) => {
    // @ts-ignore
    if (data.createUser) data.userId = undefined;
    // @ts-ignore
    if (!data.createUser) data.user = undefined;

    return data;
  };

  return (
    <Creation<CreateDeliveryManProps>
      titleBar={{title: 'Cadastrar entregador'}}
      defaultValues={{cityId}}
      onSubmit={useCreateDeliveryMan}
      {...{handleSubmit}}
      inputs={[
        getSwitch({
          name: 'createUser',
        }),
        getInput({
          name: 'user.name',
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.email',
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.password',
          secureText: true,
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.phone',
          hidden: (data) => !data.createUser,
          gridColumn: 6,
          mask: 'phone',
        }),
        getInput({
          name: 'user.emergencyPhone',
          hidden: (data) => !data.createUser,
          gridColumn: 6,
          mask: 'phone',
        }),
        getInput({
          name: 'user.cpf',
          hidden: (data) => !data.createUser,
          gridColumn: 4,
          mask: 'cpf',
        }),
        getInput({
          name: 'user.cnpj',
          hidden: (data) => !data.createUser,
          gridColumn: 4,
          mask: 'cnpj',
        }),
        getInput({
          name: 'user.cnh',
          hidden: (data) => !data.createUser,
          gridColumn: 4,
        }),
        getAddressInput({
          name: 'user.homeAddress',
          withSearch: false,
          hidden: (data) => !data.createUser,
        }),
        getSelect({name: 'userId', data, hidden: (data) => !!data.createUser}),
        getSelect({
          name: 'cityId',
          data: citiesSelect.data,
          hidden: () => !!cityId,
        }),
        getNumberInput({name: 'maxDeliveryQuantity'}),
        getSelect({
          name: 'deliveryManStatus',
          data: [
            {label: 'Offline', value: DeliveryManStatusEnum.OFFLINE},
            {label: 'Desativado', value: DeliveryManStatusEnum.DISABLED},
          ],
        }),
        getInput({
          name: 'user.pixKey',
        }),
      ]}
      translationKey={translatedCreateDeliveryManProps}
    />
  );
};

export default CreateDeliveryMen;
